/**
 * Modify array by inserting itemsToInsert at the specified index
 * @param array 
 * @param index 
 * @param itemsToInsert 
 */
export function arrayInsertAtIndex(array: any[], index: number, itemsToInsert: any[]): void {
    array.splice(index, 0, ...itemsToInsert);
}
